import { useEffect, useState, useCallback, useRef } from "react";

import { Box, CardMedia, Stack } from "@mui/material";

import { HttpClientApi, SetProdClickParams } from "../../../../components/interface/client-rest-api";
import { CommonUtils } from "../../../Utils/common_utils";
import { useInterval } from "../../../Utils/UseInterval";

import "./LiveProduct.css";

type ProdType = {
  goods_cd: string; // 상품코드
  goods_nm: string; // 상품명
  svc_type: string; // 서비스타입
  img_url: string; // 상품 이미지 URL
  pc_url: string; // pc 렌딩 URL
  mo_url: string; // mo 렌딩 URL
  sale_price: string; // 판매가
  disp_order: string; // 노출 순서
  use_yn: string; // 사용여부
};

interface propsType {
  hidden_menu: boolean;
  prodList: ProdType[];
  postMsg: any;
  isNotFloat: any;
  isFloat: any;
  broadSeq: any;
  userId: any;
  hostId?: any; // 컨설팅 링크 구분용
  liveProducts: any;
  cnslImgPath: string; // 리바트 상담신청 배너 이미지
  cnslPageUrl: string; // 리바트 상담신청 배너 랜딩 URL
  bnrImgPath: string; // 리바트 이미지배너 이미지
  bnrPageUrl: string; // 리바트 이미지배너 랜딩 URL
  loadChannelInfoOnly: any;
  openDrawer: Function;
  broadStatus: string;
}

const cUtils = new CommonUtils();

const LiveProduct = (props: propsType) => {
  const ClientApi = new HttpClientApi();
  const prodCircle = useRef<HTMLDivElement>(null);

  const [prodList, setProdList] = useState<ProdType[]>([]);
  const [prodPhotoRender, setProdPhotoRender] = useState([] as any);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    // 상품 로드
    LoadProdList();
    return () => {
      // 메모리 누수를 방지하기 위해서 컴포넌트 언마운트시 State를 초기화 한다.
      setProdList([] as any);
      setProdPhotoRender([] as any);
      setCurrentIndex(0);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let tempNow: any = [];
    let tempNotNow: any = [];
    if (props.prodList.length > 0) {
      if (props.prodList[0].goods_nm !== "") {
        for (const prod of props.prodList) {
          if (props.liveProducts.indexOf(prod.goods_cd) > -1) {
            tempNow.push({
              goods_cd: prod.goods_cd,
              goods_nm: prod.goods_nm,
              svc_type: prod.svc_type,
              img_url: prod.img_url,
              pc_url: prod.pc_url,
              mo_url: prod.mo_url,
              sale_price: prod.sale_price,
              disp_order: prod.disp_order,
              use_yn: prod.use_yn,
            });
          } else {
            tempNotNow.push({
              goods_cd: prod.goods_cd,
              goods_nm: prod.goods_nm,
              svc_type: prod.svc_type,
              img_url: prod.img_url,
              pc_url: prod.pc_url,
              mo_url: prod.mo_url,
              sale_price: prod.sale_price,
              disp_order: prod.disp_order,
              use_yn: prod.use_yn,
            });
          }
        }

        setProdList([...tempNow, ...tempNotNow]);
      }
    }
  }, [props.prodList, props.liveProducts]);

  // 상품 정보 불러오기
  const LoadProdList = () => {
    // 부모 프레임에 메시지 전달
    // 지금은 모두로 보내지만
    // 나중에 더현대 주소로 변경해야함
    // props.postMsg({ msg: "LoadProdList" }, "*");
    props.loadChannelInfoOnly();
  };

  const rollingProduct = () => {
    if (!prodCircle.current) {
      return;
    }
    prodCircle.current.style.transition = `all 3s ease-in-out`;
    prodCircle.current.style.transform = `translateY(-${currentIndex}00%)`;

    if (currentIndex === prodList.length) {
      setTimeout(() => {
        if (!prodCircle.current) {
          return;
        }
        prodCircle.current.style.transition = `0s`;
        prodCircle.current.style.transform = `translateY(0)`;
      }, 3001);
      setCurrentIndex(1);
    } else {
      setCurrentIndex(currentIndex + 1);
    }
  };

  let delayPool: number = 6000;
  useInterval(
    () => {
      rollingProduct();
    },
    prodList.length > 0 ? delayPool : null
  );

  // 상품 원 모양 버튼 이미지 슬라이드 HTML Element 설정
  const handleProdCicle = useCallback(() => {
    // console.log("handleProdCicle: 상품 출력", prodList);
    if (prodList.length > 0) {
      setProdPhotoRender(
        //props.broad_prod_list
        prodList
          .map((obj: ProdType, index: number) => {
            return (
              <div className="slideItem" key={"key" + index} onClick={() => clickProd(obj)}>
                <img className="item-thumb" src={obj.img_url} alt="" />
                <div className="item-desc">
                  <div className="item-title">
                    {props.liveProducts.indexOf(obj.goods_cd) > -1 && (
                      <span className="live-product-rolling-now">NOW</span>
                    )}
                    {obj.goods_nm}
                  </div>
                  <Stack direction="row" display="flex" alignItems="center" spacing={0.5}>
                    <div className="item-price">{cUtils.numericComma(obj.sale_price) + "원~"}</div>
                  </Stack>
                </div>
              </div>
            );
          })
          .concat(
            <div className="slideItem" key={"key_" + prodList[0].goods_cd} onClick={() => clickProd(prodList[0])}>
              <img className="item-thumb" src={prodList[0].img_url} alt="" />
              <div className="item-desc">
                <div className="item-title">
                  {props.liveProducts.indexOf(prodList[0].goods_cd) > -1 && (
                    <span className="live-product-rolling-now">NOW</span>
                  )}
                  {prodList[0].goods_nm}
                </div>
                <Stack direction="row" display="flex" alignItems="center" spacing={0.5}>
                  <div className="item-price">{cUtils.numericComma(prodList[0].sale_price) + "원~"}</div>
                </Stack>
              </div>
            </div>
          )
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prodList, props.liveProducts]);

  useEffect(() => {
    // 상품 사진 슬라이드
    handleProdCicle();
  }, [handleProdCicle]);

  const handleProdDrawerClose = () => {
    props.isFloat();
  };
  const handleProdDrawerOpen = () => {
    props.openDrawer("prod");
  };

  const handleProdOpen = () => {
    // 품절 상태 확인하기 위해 다시 상품 리스트 호출
    LoadProdList();
    // floating 막기
    props.isNotFloat();
    // Drawer 오픈 함수
    handleProdDrawerOpen();
  };

  const clickProd = async (prod: ProdType) => {
    handleProdDrawerClose();
    if (props.broadStatus === "START" || props.broadStatus === "READY") {
      const msgPayload = {
        func: "openGoodsDetail",
        goods_cd: prod.goods_cd,
        svc_type: prod.svc_type,
        mo_url: prod.mo_url,
      };

      props.postMsg(msgPayload, "*");

      try {
        let param: SetProdClickParams = {
          broad_seq: props.broadSeq,
          user_id: props.userId,
          prod_id: prod.goods_cd,
          prod_name: prod.goods_nm,
          prod_price: `${prod.sale_price}`,
        };

        await ClientApi.set_prod_click(param).then((res) => {
          // console.log(`상품 클릭 이벤트 : ${res}`);
        });
      } catch (e) {
        console.error("set_prod_click ERROR : ", e);
      }
    }
  };

  return (
    <>
      {(prodList.length > 0 || props.cnslImgPath !== "") && (
        <Box component="div" sx={{ width: "100%" }} className="color-snow">
          <Box sx={{ p: "8px 14px" }}>
            <Stack
              direction="row"
              spacing={0}
              sx={{
                width: "100%",
                alignItems: "flex-end",
                justifyContent: "flex-start",
                // marginBottom: `${props.hidden_menu && props.chat_open ? "41px" : "0"}`
              }}
            >
              <Box
                sx={
                  props.hidden_menu
                    ? { display: "none" }
                    : prodList.length === 0 && props.cnslImgPath === ""
                    ? { display: "none" }
                    : { display: "flex", justifyContent: "space-between" }
                }
                className="prod-circle-button-box white-shadow"
              >
                {prodList.length > 0 ? (
                  //상품 리스트 롤링
                  <>
                    <Box className="prod-circle-button ">
                      <div className="slider-circle" ref={prodCircle}>
                        {prodPhotoRender}
                      </div>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center" }} onClick={handleProdOpen}>
                      <Box sx={{ border: "0.3px solid #DDDDDD", height: "45px" }}></Box>
                      <Box className="prod-circle-cnt">
                        <span>{prodList.length}</span>
                        <span style={{ fontSize: "11px" }}>더보기</span>
                      </Box>
                    </Box>
                  </>
                ) : (
                  <></>
                )}
              </Box>
            </Stack>
          </Box>
        </Box>
      )}
    </>
  );
};

export default LiveProduct;
